import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig.js";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Assuming you have a similar function to log actions
import { getDocDataByRef } from "../../models/DataFunctions.js";

const sendHexamail = async (
  email_delivered_id,

  token,

  prefix
) => {
  // Define the endpoint URL
  const url = prefix + "track/send-email/" + email_delivered_id;

  // Retrieve users from the organization
  const db = getFirestore();

  // Define the request body
  const body = {};

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    let start = new Date();
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      console.error("User not logged in");
      return "";
    }

    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return "";
    }

    const org_id = userSnapshot.get("org_id");

    // Add log document (avoid passing full document references)
    let end = new Date();
    let elapsed = end - start;
    await addLogDocument(
      url,
      prefix,
      userRef, // Only log the userRef ID
      org_id,
      response.status.toString(),
      "", // folderid
      "", // docid
      JSON.stringify(body), // request body as string
      await response.text(),
      "POST",
      elapsed
    );

    // Check if the request was successful
    if (response.ok) {
      return "Email sent successfully";
    } else {
      console.error(`Failed to send email: ${response.status}`);
      return `Failed to send email: ${response.status}`;
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    return `Exception occurred: ${error.message}`;
  }
};

export default sendHexamail;
